// Campos "Clase de señal (A/A+)" del panel de configuración -- WP A/A+
// fase 2, hoy solo en NASDAQ Quantum (alcance de Marc: indicador a
// indicador). El Panel lo envuelve en su propia <Section> (acordeón con
// estado persistido) y le pasa su `update(key, value)`.
//
// m y f son los de backend/app/core/signal_class.py (utils/signalClass.js,
// paridad obligatoria): por defecto m = 2 y f = 0,12 % (taker Bitunix ida +
// vuelta). Cambiarlos solo re-etiqueta ESTE chart -- tarjeta y bots siguen
// con los del backend, y el panel lo avisa en cuanto difieren.
import { DEFAULT_F, DEFAULT_M, classParamsDiffer, resolveClassParams } from '@/utils/signalClass'

const INPUT_CLS =
  'w-24 px-2 py-1 text-[11px] rounded border border-[var(--hair,rgba(176,141,87,0.35))] bg-white dark:bg-gray-100 ' +
  'text-gray-900 placeholder:text-gray-400 text-right [appearance:textfield] ' +
  '[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'

const fmt = (n) => n.toLocaleString('es-ES', { maximumFractionDigits: 4 })

export default function SignalClassConfigFields({ config, update }) {
  const params = resolveClassParams(config)
  // Valor vacío o no válido → vuelve al default (nunca NaN en la comparación).
  const onNum = (key, fallback) => (e) => {
    const raw = e.target.value
    const n = Number(String(raw).replace(',', '.'))
    update(key, raw === '' || !Number.isFinite(n) || n < 0 ? fallback : n)
  }
  return (
    <div className="space-y-2" data-testid="signal-class-config">
      <div className="flex items-center justify-between gap-2">
        <label htmlFor="sc-m" className="text-xs text-slate-700 dark:text-gray-200">Multiplicador m</label>
        <input id="sc-m" type="number" min="0" step="0.1" className={INPUT_CLS}
          value={params.m} onChange={onNum('signalClassM', DEFAULT_M)} />
      </div>
      <div className="flex items-center justify-between gap-2">
        <label htmlFor="sc-f" className="text-xs text-slate-700 dark:text-gray-200">Coste f (% ida + vuelta)</label>
        <input id="sc-f" type="number" min="0" step="0.01" className={INPUT_CLS}
          value={params.f} onChange={onNum('signalClassFeePct', DEFAULT_F)} />
      </div>
      <p className="text-[10px] text-slate-500 dark:text-gray-400 leading-relaxed">
        A+ si la distancia de la entrada a TP1 es ≥ m × f = {fmt(params.m * params.f)} %; si no, A.
        Las dos clases se muestran siempre: la etiqueta solo informa. Por defecto m = {fmt(DEFAULT_M)} y
        f = {fmt(DEFAULT_F)} % (taker Bitunix), los mismos que la tarjeta de Telegram y los bots.
      </p>
      {classParamsDiffer(params) && (
        <p className="text-[10px] leading-relaxed text-amber-600" role="alert">
          Con estos valores las etiquetas del chart pueden no coincidir con las de Telegram ni con el filtro
          «Solo A+» de los bots, que usan m = {fmt(DEFAULT_M)} y f = {fmt(DEFAULT_F)} %.
        </p>
      )}
    </div>
  )
}
